export default {
  'forgetpassword.forgetpassword': 'Haben Sie Ihr Password vergessen?',
  'forgetpassword.wrongemail': 'Email war nicht gültig',
  'forgetpassword.resetemail':
    'Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzend',
  'forgetpassword.resetpassword': 'Passwort zurücksetzen',
};
